import en from './en.js'

// Turkish locale:
// keep full key coverage via English fallback, and override
// high-traffic modules with Turkish copy.
export default {
  ...en,

  topHeader: {
    ...en.topHeader,
    '选择网络': 'Ag Sec',
    'ERC20-USDC': 'ERC20-USDC',
    'ERC20-USDT': 'ERC20-USDT',
    '登录进行中': 'Giris yapiliyor...',
    '连接钱包': 'Cuzdani Bagla',
    '连接中': 'Baglaniyor...',
    '已连接': 'Bagli',
    '连接成功': 'Baglanti Basarili!',
    '钱包已成功连接': 'Cuzdan basariyla baglandi',
    '钱包信息': 'Cuzdan Bilgisi',
    '钱包地址': 'Cuzdan Adresi',
    '断开连接': 'Baglantiyi Kes',
    '已断开连接': 'Baglanti kesildi',
    '正在初始化': 'Baslatiliyor...',
    '正在切换网络': 'Ag degistiriliyor...',
    '登录完成': 'Giris tamamlandi',
    '请在钱包中确认': 'Lutfen cuzdanda onaylayin',
    '登录成功': 'Giris basarili',
    '钱包连接失败': 'Cuzdan baglantisi basarisiz',
    '未知错误': 'Bilinmeyen hata',
    '认证失败，请重试连接钱包': 'Dogrulama basarisiz, lutfen tekrar deneyin',
    '钱包连接请求正在处理中，请稍等或刷新页面后重试': 'Baglanti istegi isleniyor, lutfen bekleyin veya sayfayi yenileyin',
    '钱包连接请求正在等待处理，请在钱包中确认': 'Baglanti istegi beklemede, lutfen cuzdanda onaylayin',
    '授权失败': 'Yetkilendirme basarisiz',
    '交易被撤销，可能是合约错误或余额不足': 'Islem geri alindi, sozlesme hatasi veya bakiye yetersiz olabilir',
    '欢迎！您的账户已创建成功': 'Hos geldiniz! Hesabiniz basariyla olusturuldu',
    '钱包连接成功': 'Cuzdan baglandi',
    '钱包已断开连接': 'Cuzdan baglantisi kesildi',
    '是否断开钱包连接？': 'Cuzdan baglantisini kesmek istiyor musunuz?',
    '钱包未连接，请先连接钱包': 'Cuzdan bagli degil, once baglayin',
    '中文（简体）': 'Cince (Basitlestirilmis)',
    '用户取消了授权': 'Kullanici yetkilendirmeyi iptal etti',
    'ETH余额不足，无法支付Gas费用': 'ETH bakiyesi yetersiz, gas ucreti odenemiyor',
    'Gas费用设置过低': 'Gas ucreti cok dusuk ayarlanmis',
    '交易nonce错误，请重试': 'Nonce hatasi, lutfen tekrar deneyin',
    'Gas价格过低，请提高Gas价格': 'Gas fiyati cok dusuk, lutfen artirin',
    '合约参数错误，请检查网络和合约地址': 'Sozlesme parametre hatasi, agi ve adresi kontrol edin',
    '余额不足，无法完成授权': 'Bakiye yetersiz, yetkilendirme tamamlanamadi',
    '请安装 MetaMask 或其他以太坊钱包': 'Lutfen MetaMask veya baska bir Ethereum cuzdani kurun',
    '请安装 TronLink 钱包': 'Lutfen TronLink cuzdani kurun',
    '未找到授权目标地址，请先获取系统配置': 'Yetkilendirme hedef adresi bulunamadi, once sistem ayarini alin',
    '获取授权地址失败': 'Yetkilendirme adresi alinamadi',
    '不支持的网络类型': 'Desteklenmeyen ag tipi',
    '网络切换可能未完成，当前链ID': 'Ag degisimi tamamlanmamis olabilir, mevcut zincir ID',
    '请刷新页面重试': 'Lutfen sayfayi yenileyip tekrar deneyin',
    '网络连接失败': 'Ag baglantisi basarisiz',
    '授权地址格式错误': 'Yetki adres formati hatali',
    '合约地址格式错误': 'Sozlesme adres formati hatali',
    'ETH余额不足！当前余额': 'ETH bakiyesi yetersiz! Mevcut bakiye',
    '需要': 'Gerekli',
    '钱包连接请求正在等待处理，请在MetaMask中确认': 'Baglanti istegi beklemede, MetaMaskta onaylayin',
    '钱包连接请求正在等待处理，请在Trust Wallet中确认': 'Baglanti istegi beklemede, Trust Walletta onaylayin',
    '钱包连接请求正在等待处理，请在Coinbase Wallet中确认': 'Baglanti istegi beklemede, Coinbase Walletta onaylayin',
    '确定': 'Tamam'
  },

  flashOptions: {
    '闪电期权': 'Flash Opsiyonlar',
    '请先连接钱包': 'Lütfen cüzdanınızı bağlayın',
    '连接钱包后即可开始闪电期权交易': 'Flash opsiyon ticaretine başlamak için cüzdanınızı bağlayın',
    '连接钱包': 'Cüzdan bağla',
    '加载中': 'Yükleniyor...',
    '暂无可交易资产': 'İşlem yapılabilir varlık yok',
    '请稍后再试': 'Lütfen daha sonra tekrar deneyin',
    '时间': 'Süre',
    '金额': 'Tutar',
    '回报额': 'Getiri',
    '利润': 'Kâr',
    '当前持仓': 'Açık pozisyonlar',
    '暂无持仓': 'Pozisyon yok',
    '买涨': '▲ Yükseliş',
    '买跌': '▼ Düşüş',
    '开仓': 'Açılış',
    '入场价': 'Giriş fiyatı',
    '出场价': 'Çıkış fiyatı',
    '收益率': 'Getiri',
    '投入': 'Miktar',
    '入场时间': 'Giriş zamanı',
    '出场时间': 'Çıkış zamanı',
    '实时价': 'Canlı Fiyat',
    '倒计时': 'Geri Sayım',
    '交易记录': 'İşlem geçmişi',
    '暂无记录': 'Kayıt yok',
    '涨': 'Yükseliş',
    '跌': 'Düşüş',
    '秒': 'sn',
    '分钟': 'dk',
    '结算中': 'Takas ediliyor...',
    '加载配置失败': 'Yükleme başarısız',
    '请完善交易信息': 'Lütfen bilgileri tamamlayın',
    '下单失败': 'Emir başarısız',
    '买涨成功': 'Yükseliş alımı başarılı',
    '买跌成功': 'Düşüş alımı başarılı',
    '等待行情数据': 'Piyasa verisi bekleniyor...',
    '余额不足': 'Yetersiz bakiye',
    '资产不可用': 'Varlık kullanılamaz',
    '周期不可用': 'Dönem kullanılamaz',
    '智能交易': 'AI Ticaret',
    '交易标的': 'Varlık',
    '风险类型': 'Risk türü',
    '投入金额': 'Tutar',
    '提交申请': 'Gönder',
    '我的AI订单': 'AI Emirlerim',
    '稳健型': 'Muhafazakâr',
    '平衡型': 'Dengeli',
    '进取型': 'Agresif',
    '稳健': 'Güvenli',
    '平衡': 'Dengeli',
    '进取': 'Agresif',
    '低风险低回报适合稳健投资者': 'Düşük risk, düşük getiri. Muhafazakâr yatırımcılar için.',
    '中等风险中等回报适合大多数投资者': 'Orta risk, orta getiri. Çoğu yatırımcı için.',
    '高风险高回报适合激进投资者': 'Yüksek risk, yüksek getiri. Agresif yatırımcılar için.',
    '待审核': 'Beklemede',
    '运行中': 'Çalışıyor',
    '已停止': 'Durduruldu',
    '已结算': 'Sonuçlandı',
    '已驳回': 'Reddedildi',
    'AI剩余': 'Kalan',
    'AI做单': 'İşlemler',
    'AI笔': '',
    'AI胜': 'K',
    'AI负': 'M',
    '请先选择交易标的': 'Lütfen önce bir varlık seçin',
    '请输入有效金额': 'Lütfen geçerli bir tutar girin',
    'AI交易申请已提交': 'AI ticaret gönderildi, inceleme bekleniyor',
    'AI提交失败': 'Gönderim başarısız',
    '停止交易': 'Durdur',
    '确认停止AI交易': 'AI ticaretini durdurmak istiyor musunuz? Kalan bakiye iade edilecek.',
    '停止失败': 'Durdurma başarısız',
    '确认取消AI申请': 'Bu AI başvurusunu iptal etmek istiyor musunuz? Dondurulmuş bakiye iade edilecek.',
    '取消失败': 'İptal başarısız',
    '体验金': 'Demo',
    '体验金不足': 'Yetersiz deneme bakiyesi',
    '可用余额': 'Bakiye',
    '累计盈亏': 'PnL',
  },

  bottomNav: {
    ...en.bottomNav,
    '首页': 'Anasayfa',
    '投资': 'Yatırım',
    '算力申请': 'Wealth',
    '闪期权': 'Flash',
    '资产': 'Profil'
  },

  assets: {
    ...en.assets,
    '总资产': 'Toplam Varlik',
    '复制成功': 'Basariyla kopyalandi',
    '我的余额(元)': 'Bakiyem (Yuan)',
    '总收入': 'Toplam Gelir',
    '今日收入': 'Bugunku Gelir',
    '今日收益': 'Bugunku Getiri',
    '昨日收益': 'Dunku Getiri',
    '体验金': 'Deneme Bakiyesi',
    '空投奖励': 'Airdrop Odulu',
    '充值': 'Yatir',
    '快速充值说明': 'USDCyi hizlica yatir',
    '提现': 'Cek',
    '邀请': 'Davet',
    '白皮书': 'Whitepaper',
    '幸运轮': 'Sans Carki',
    '站内信': 'Mesajlar',
    '信用分': 'Kredi Puani',
    '快捷邀请': 'Davet',
    '快捷白皮书': 'Whitepaper',
    '快捷幸运轮': 'Sans',
    '快捷信用分': 'Kredi',
    'VIP等级': 'VIP Seviyesi',
    '暂无VIP等级数据': 'VIP seviye verisi yok',
    '我的账户': 'Hesabim',
    '申请备用金': 'Yedek Fon Basvurusu',
    '设置资金密码': 'Fon Sifresi Ayarla',
    '选择语言': 'Dil Sec',
    '英语': 'Ingilizce',
    '钱包未连接，触发钱包连接': 'Cuzdan bagli degil, baglanti baslatiliyor',
    '钱包地址无效，重新连接': 'Cuzdan adresi gecersiz, yeniden baglaniyor',
    '钱包已连接，直接跳转到充值页面': 'Cuzdan bagli, dogrudan yatirma sayfasina gidiliyor',
    '检查授权状态失败': 'Yetki durumu kontrol edilemedi',
    '白皮书功能': 'Whitepaper ozelligi',
    '检查资金密码状态失败': 'Fon sifresi durumu kontrol edilemedi',
    'Token不存在，显示默认余额': 'Token yok, varsayilan bakiye gosteriliyor',
    '调用API获取用户余额数据': 'Kullanici bakiye verisi icin API cagriliyor...',
    '体验金加载成功': 'Deneme bakiyesi basariyla yuklendi',
    '总资产计算完成': 'Toplam varlik hesaplamasi tamamlandi',
    '余额': 'Bakiye',
    '质押金额': 'Hashrate Tutari',
    'API返回失败': 'API basarisiz dondu',
    '加载用户余额失败': 'Kullanici bakiyesi yuklenemedi',
    'Token不存在，显示默认收益': 'Token yok, varsayilan getiri gosteriliyor',
    '调用API获取用户收益数据': 'Kullanici getiri verisi icin API cagriliyor...',
    '收益数据加载成功': 'Getiri verisi basariyla yuklendi',
    '收益API返回失败': 'Getiri API basarisiz dondu',
    '加载用户收益失败': 'Kullanici getirisi yuklenemedi',
    '使用默认收益数据': 'Varsayilan getiri verisi kullaniliyor',
    '信用分加载成功': 'Kredi puani basariyla yuklendi',
    '中文（简体）': 'Cince (Basitlestirilmis)',
    '钱包地址': 'Cuzdan Adresi',
    '调用API获取空投奖励数据': 'Airdrop odul verisi icin API cagriliyor...',
    '打开客服': 'Musteri hizmetlerini ac',
    '客服功能开发中，敬请期待！': 'Musteri hizmeti gelistirme asamasinda.',
    '资产页面已加载': 'Varliklar sayfasi yuklendi'
  },

  home: {
    ...en.home,
    'titleLine1': 'HamiltonLane',
    'titleLine2': 'Private Markets. Professional Allocation.',
    'mainTitle': 'HamiltonLane: Private Markets Investment Solutions',
    'mainDescription': 'We partner with clients to conceive, build, establish, manage, and monitor private market fund and direct investment portfolios—helping every investor access quality opportunities worldwide.',
    'heroIntro': 'A professional investment platform built for high-net-worth clients',
    'heroPoint1': 'Private markets expertise across funds and direct investments',
    'heroPoint2': 'Global opportunity access for diversified private market exposure',
    'heroPoint3': 'Institutional process from conception through ongoing monitoring',
    'startJoining': 'Get Started',
    'investmentTitle': 'Investment Solutions',
    'investmentSubtitle': 'End-to-end partnership across the private markets lifecycle',
    'category1Title': 'Portfolio Conception & Strategy',
    'category1Short': 'Align objectives, risk appetite, and allocation themes for private markets.',
    'category1Full': 'We work closely with clients to clarify goals and liquidity needs, then design a clear private markets blueprint across private equity, credit, real estate, and infrastructure.',
    'category2Title': 'Fund & Direct Investment Build',
    'category2Short': 'Help structure private market funds and construct direct investment portfolios.',
    'category2Full': 'From opportunity screening and diligence to portfolio construction, we support disciplined allocation decisions that balance diversification and long-term return potential.',
    'category3Title': 'Global Opportunity Access',
    'category3Short': 'Help investors reach private market opportunities around the world.',
    'category3Full': 'Through a global private markets network, we connect clients to opportunities across regions and strategies, lowering access barriers for high-net-worth investors.',
    'category4Title': 'Portfolio Management',
    'category4Short': 'Continuously manage funds and direct investments with performance tracking.',
    'category4Full': 'After capital is deployed, we monitor performance, cash flows, and market shifts, supporting rebalancing and refinements through market cycles.',
    'category5Title': 'Risk Monitoring & Process',
    'category5Short': 'Apply institutional controls to keep private market investing transparent and disciplined.',
    'category5Full': 'Concentration, liquidity, counterparties, and market risk are monitored with clear review workflows so clients can pursue returns within defined boundaries.',
    'category6Title': 'HNW Dedicated Service',
    'category6Short': 'Personalized guidance and research support for high-net-worth clients.',
    'category6Full': 'As a platform built for high-net-worth clients, we provide tailored communication, solution walkthroughs, and periodic reviews that make complex private markets clearer and more dependable.',
    'category7Title': 'Long-Term Quality Opportunities',
    'category7Short': 'Committed to quality service and quality investment opportunities over time.',
    'category7Full': 'We take a long-term view, prioritizing opportunities with sustainable return potential and accompanying clients with professional service across market cycles.',
    'more': 'Daha Fazla',
    'collapse': 'Daralt',
    'earningsTitle': 'Performance',
    'earningsSubtitle': 'Selected account returns',
    'walletAddressLabel': 'Cuzdan Adresi',
    'profitLabel': 'Kar',
    'walletConnected': 'Cuzdan Bagli',
    'walletNotConnected': 'Cuzdan Bagli Degil',
    'heroMarketTag': 'Private Markets',
    'metricPnl': '24s K/Z',
    'metricWinRate': 'Kazanma Orani',
    'metricActiveBots': 'Aktif Botlar',
    'companyTitle': 'About the Platform',
    'companyShort': 'HamiltonLane, Singapur merkezli kuresel yuksek teknoloji sirketidir.',
    'companyFull': 'HamiltonLane, yapay zeka ve blokzinciri birlestiren kuresel bir teknoloji sirketidir. Sirket, hesaplama gucu aglari ve akilli varlik yonetimi altyapisi gelistirmeye odaklanir.',
    'persistentLink': 'Persistent Systems Hakkinda',
    'tradingBotsLink': 'Visit Website',
    'companyTitleHB': 'About the Platform',
    'companyShortHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. Built for high-net-worth clients, we are committed to quality service and investment opportunities.',
    'companyFullHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. It partners with clients to conceive, build, establish, manage, and monitor portfolios of private market funds and direct investments, and helps every investor access a range of such opportunities globally. Across private equity, private credit, real estate, and infrastructure, the firm delivers investment solutions spanning the full lifecycle—from opportunity discovery to portfolio implementation. Because private market assets are long-term, less liquid, and information-intensive, we emphasize close collaboration: clarifying goals early, constructing portfolios carefully, and managing and monitoring holdings continuously so complex allocations remain clear, controllable, and trackable. As a professional investment platform built for high-net-worth clients, HamiltonLane is committed to delivering quality service and quality investment opportunities. Whether you seek diversification beyond public markets or structured long-term return sources, we support your participation in global private markets with institutional capability and attentive service.',
    'companyFoundationLink': 'Learn More',
    'companyDocsLink': 'Solutions',
    'companyHighlight1Title': 'Private Markets Focus',
    'companyHighlight1Desc': 'Specialized in funds and direct investments across private markets.',
    'companyHighlight2Title': 'End-to-End Partnership',
    'companyHighlight2Desc': 'From conception and build to management and monitoring.',
    'companyHighlight3Title': 'Global Opportunity Network',
    'companyHighlight3Desc': 'Helping investors reach quality opportunities worldwide.',
    'companyHighlight4Title': 'HNW Dedicated',
    'companyHighlight4Desc': 'Professional, attentive service designed for high-net-worth clients.',
    'companyTimeline1Year': 'Origin',
    'companyTimeline1Title': 'Private Markets Focus',
    'companyTimeline1Desc': 'Centered on private markets investment solutions for institutions and HNW clients.',
    'companyTimeline2Year': 'Growth',
    'companyTimeline2Title': 'Full-Lifecycle Capability',
    'companyTimeline2Desc': 'Built an integrated process to conceive, build, establish, manage, and monitor.',
    'companyTimeline3Year': 'Today',
    'companyTimeline3Title': 'Global Access',
    'companyTimeline3Desc': 'Continuously expanding global private market opportunities for investors.',
    'faqTitle': 'Sik Sorulan Sorular',
    'faq1Question': 'What does HamiltonLane provide?',
    'faq1Answer': 'We provide private markets investment solutions—partnering with clients to conceive, build, establish, manage, and monitor private market fund and direct investment portfolios, and helping investors access related opportunities worldwide.',
    'faq2Question': 'Who is the platform for?',
    'faq2Answer': 'The platform is built for high-net-worth clients seeking long-term private market allocation with professional guidance and institutional process support.',
    'faq3Question': 'How do I get started?',
    'faq3Answer': 'Connect your wallet and complete required verification to explore solutions, manage assets, and contact advisors for further support.',
    'partnerTitle': 'Partners',
    'customerServiceDevelopment': 'Musteri hizmeti gelistirme asamasindadir.'
  },

  computing: {
    ...en.computing,
    '平台资产': 'Platform Bakiyesi',
    '质押金额': 'Hashrate Tutari',
    '基础算力': 'Temel Hashrate',
    '高级算力': 'Gelismis Hashrate',
    '超级算力': 'Super Hashrate',
    '超级算力申请': 'Hashrate Kiralama',
    '申请解押': 'Hashrate Geri Alma',
    '申请中': 'Basvuruluyor...',
    '请选择算力方案': 'Bir hashrate plani secin',
    '请先选择算力方案': 'Lutfen once bir hashrate plani secin',
    '短算力类型': 'Tur',
    '短算力周期': 'Sure',
    '短预计日收益': 'Gunluk Tahmini',
    '短剩余次数': 'Kalan',
    '短解押记录': 'Geri Alma',
    '短算力记录': 'Kiralama Kayitlari',
    '短质押明细': 'Hashrate',
    '短待审': 'Bekliyor',
    '短成功': 'Onay',
    '短失败': 'Red',
    '短完成': 'Bitti',
    '短赎回记录': 'Geri Alim Kayitlari',
    '步骤提示租赁': 'Adim 1: bir hashrate plani secin. Adim 2: "Hashrate Kiralama" dugmesine basin.',
    '解押金额': 'Geri Alim Tutari',
    '申请天数': 'Kiralama Suresi',
    '金额': 'Tutar',
    '后值': 'Sonraki Deger',
    '未连接钱包': 'Cuzdan bagli degil',
    '登录已过期': 'Oturum suresi doldu',
    '请重新连接钱包': 'Lutfen cuzdani yeniden baglayin',
    '加载失败': 'Yukleme basarisiz',
    '获取质押记录失败': 'Hashrate kayitlari alinamadi',
    '我的算力订单': 'Hashrate Siparişlerim',
    '总质押': 'Toplam Stake',
    '总收益': 'Toplam Kazanç',
    '进行中': 'Aktif',
    '剩余天数': 'Kalan Gün',
    '暂无算力订单': 'Hashrate siparişi yok',
    '状态待审核': 'Incelemede',
    '状态成功': 'Onaylandi',
    '状态失败': 'Reddedildi',
    '状态进行中': 'Devam Ediyor',
    '状态已完成': 'Tamamlandi',
    '状态已取消': 'Iptal Edildi',
    '状态未知': 'Bilinmiyor',
    '确认解押': 'Geri Almayi Onayla',
    '处理中': 'Isleniyor',
    '取消': 'Iptal',
    '正在加载记录': 'Kayitlar yukleniyor...',
    '正在加载质押记录': 'Hashrate kayitlari yukleniyor...',
    '暂无记录': 'Kayit yok',
    '暂无质押记录': 'Hashrate kaydi yok',
    '正在加载详情': 'Detaylar yukleniyor...',
    '申请周期': 'Kiralama Suresi',
    '基本信息': 'Temel Bilgiler',
    '算力类型': 'Hashrate Turu',
    '申请时间': 'Basvuru Zamani',
    '暂无数据': 'Veri yok',
    '加载失败请重试': 'Yukleme basarisiz, lutfen tekrar deneyin',
    '重新加载': 'Yeniden Yukle',
    '包含累计收益': 'Toplam getiri dahil',
    '解押后资金将退回到平台资产中不再产生收益': 'Geri alim sonrasi tutar platform bakiyesine doner ve getiri durur',
    '解押审核中': 'Geri alim incelemede',
    '已解押': 'Geri alim tamamlandi',
    '无法获取申请详情': 'Basvuru detayi alinamadi',
    '请检查网络连接后重试': 'Ag baglantinizi kontrol edip tekrar deneyin',
    '解押申请已提交': 'Geri alim basvurusu gonderildi',
    '请等待审核处理': 'Lutfen inceleme sonucunu bekleyin',
    '解押申请失败': 'Geri alim basvurusu basarisiz',
    '无法获取算力设置': 'Hashrate ayarlari alinamadi',
    '获取算力收益等级失败': 'Hashrate getiri seviyeleri alinamadi',
    '参数错误': 'Parametre hatasi',
    '设置错误': 'Ayar hatasi',
    '未找到对应的算力设置': 'Secilen hashrate ayari bulunamadi',
    '钱包地址无效': 'Gecersiz cuzdan adresi',
    '地址格式错误': 'Adres formati gecersiz',
    '需要连接钱包才能申请算力': 'Hashrate kiralama icin cuzdan baglamaniz gerekir',
    '需要连接钱包才能申请解押': 'Geri alim basvurusu icin cuzdan baglamaniz gerekir',
    '申请金额': 'Basvuru Tutari',
    '请输入申请金额': 'Lutfen basvuru tutarini girin',
    '最大可申请金额': 'Maksimum basvuru tutari',
    '投入限额': 'Yatirim Limiti',
    '最低投入': 'Minimum Yatirim',
    '最大投入': 'Maksimum Yatirim',
    '短投入限额': 'Limit',
    '请输入有效金额': 'Lutfen gecerli bir tutar girin',
    '请输入有效的申请金额': 'Lutfen gecerli bir basvuru tutari girin',
    '申请金额不能低于最低投入': 'Basvuru tutari minimum yatirimin altinda olamaz',
    '申请金额不能高于最大投入': 'Basvuru tutari maksimum yatirimi asamaz',
    '请输入大于0的解押金额': 'Lutfen 0dan buyuk geri alim tutari girin',
    '质押金额不足': 'Hashrate tutari yetersiz',
    '解押金额不能超过当前质押金额': 'Geri alim tutari mevcut hashrate tutarini asamaz',
    '余额不足': 'Bakiye yetersiz',
    '您的账户余额不足，无法申请算力': 'Hesap bakiyesi yetersiz, hashrate kiralama yapilamaz',
    '申请提交成功': 'Basvuru basariyla gonderildi',
    '申请提交失败': 'Basvuru gonderimi basarisiz',
    '请稍后重试': 'Lutfen daha sonra tekrar deneyin',
    '您的解押申请已提交，请等待审核': 'Geri alim basvurunuz gonderildi, lutfen incelemeyi bekleyin',
    '您的算力申请已提交，请等待审核': 'Hashrate kiralama basvurunuz gonderildi, lutfen incelemeyi bekleyin',
    '申请失败，请重试': 'Basvuru basarisiz, lutfen tekrar deneyin',
    '您还有待审核的申请，请等待审核完成后再提交新申请': 'Incelemede basvurunuz var, lutfen sonuc bekledikten sonra yeni basvuru yapin',
    '您还有未解押的算力订单，无法申请新的算力': 'Geri alinmamis hashrate emriniz var, yeni basvuru yapamazsiniz',
    '申请次数已用完，最大申请次数': 'Basvuru limiti doldu',
    '没有可解押的金额': 'Geri alim icin uygun tutar yok',
    '您已有待处理的解押申请，请等待审核': 'Islemde geri alim basvurunuz var, lutfen incelemeyi bekleyin',
    '每日收益记录': 'Gunluk Getiri Kayitlari',
    '累计收益': 'Toplam Getiri',
    '加载收益记录': 'Getiri kayitlari yukleniyor...',
    '管理员操作': 'Yonetici Islemi',
    '收益': 'Getiri',
    '质押': 'Hashrate Isleme',
    '解押': 'Geri Alma',
    '充值': 'Yatirma',
    '提现': 'Cekim',
    '奖励': 'Odul',
    '推荐奖励': 'Referans Odulu',
    '系统调整': 'Sistem Duzenlemesi',
    '算力收益': 'Hashrate Getirisi',
    '机器人收益': 'Robot Getirisi',
    '申请赎回': 'Hashrate İade Et',
    '赎回金额': 'İade Tutarı',
    '赎回审核中': 'İade İnceleniyor',
    '未到期不可赎回': 'Vade dolmadan iade edilemez',
    '暂不可赎回': 'Henüz İade Edilemez',
    '当前算力未到期': 'Mevcut hashrate vadesi dolmadı, vade sonrası iade mümkün olacak',
    '需要连接钱包才能申请赎回': 'İade başvurusu için cüzdan bağlanmalı',
    '您的赎回申请已提交，请等待审核': 'İade başvurunuz gönderildi, lütfen incelemeyi bekleyin',
    '确认赎回': 'İadeyi onayla',
    '已赎回': 'İade edildi',
    '您已有待处理的赎回申请，请等待审核': 'Zaten bekleyen bir iade başvurunuz var, lütfen bekleyin',
    '当前状态不允许赎回': 'Mevcut durum iadeye izin vermiyor',
    '没有可赎回的金额': 'İade edilebilir tutar yok',
},

  computingApplications: {
    ...en.computingApplications,
    '算力申请记录': 'Hashrate Kiralama Kayitlari',
    '短算力记录': 'Kiralama Kayitlari',
    '短算力类型': 'Tur',
    '短算力周期': 'Sure',
    '短预计日收益': 'Gunluk Tahmini',
    '短申请时间': 'Basvuru',
    '短状态': 'Durum'
  },

  recharge: {
    ...en.recharge,
    '充值': 'Yatir',
    '返回': 'Geri',
    '充值记录': 'Yatirma Gecmisi',
    '选择金额': 'Tutar Sec',
    '确认订单': 'Siparisi Onayla',
    '完成转账': 'Transferi Tamamla',
    '请输入充值金额': 'Yatirma tutari girin',
    '自定义': 'Ozel',
    '下一步': 'Sonraki',
    '上一步': 'Onceki',
    '订单信息': 'Siparis Bilgisi',
    '订单号': 'Siparis No',
    '充值金额': 'Yatirma Tutari',
    '最小充值金额提示': 'En az 500 USDC',
    '网络': 'Ag',
    '代币': 'Token',
    '收款地址': 'Alici Adresi',
    '创建订单': 'Siparis Olustur',
    '创建中': 'Olusturuluyor...',
    '开始转账': 'Transferi Baslat',
    '重新转账': 'Tekrar Transfer Et'
  },

  rechargeHistory: {
    ...en.rechargeHistory,
    '充值记录': 'Yatirma Gecmisi',
    '全部': 'Tum',
    '待支付': 'Odeme Bekliyor',
    '待审核': 'Inceleme Bekliyor',
    '确认中': 'Onaylaniyor',
    '成功': 'Basarili',
    '已完成': 'Tamamlandi',
    '已取消': 'Iptal Edildi',
    '待确认': 'Onay Bekliyor',
    '已到账': 'Hesaba Gecti',
    '失败': 'Basarisiz',
    '暂无记录': 'Kayit Yok',
    '加载中': 'Yukleniyor',
    '加载更多': 'Daha Fazla',
    '没有更多数据': 'Daha fazla veri yok',
    '暂无充值记录': 'Yatirma kaydi yok',
    '立即充值': 'Simdi Yatir',
    '充值': 'Yatir',
    '订单号': 'Siparis No',
    '刚刚': 'Simdi',
    '分钟前': ' dakika once',
    '小时前': ' saat once'
  },

  rechargeDetail: {
    ...en.rechargeDetail,
    '充值详情': 'Yatirma Detayi',
    '返回': 'Geri',
    '订单信息': 'Siparis Bilgisi',
    '链上信息': 'Zincir Bilgisi',
    '状态': 'Durum',
    '加载中': 'Yukleniyor',
    '订单不存在或已删除': 'Siparis yok veya silinmis',
    '订单号': 'Siparis No',
    '充值网络': 'Yatirma Agi',
    '订单状态': 'Siparis Durumu',
    '创建时间': 'Olusturma Zamani',
    '支付时间': 'Odeme Zamani',
    '确认时间': 'Onay Zamani',
    '完成时间': 'Tamamlanma Zamani',
    '转账信息': 'Transfer Bilgisi',
    '充值地址': 'Yatirma Adresi',
    '复制': 'Kopyala',
    '交易哈希': 'Islem Hash',
    '确认进度': 'Onay Ilerlemesi',
    '确认': 'Onay',
    '查看区块浏览器': 'Blok Gezgini Ac',
    '取消订单': 'Siparisi Iptal Et',
    '交易信息': 'Islem Bilgisi',
    '区块确认数': 'Blok Onay Sayisi',
    '手续费': 'Ucret',
    '备注': 'Not',
    '金额': 'Tutar',
    '待支付': 'Odeme Bekliyor',
    '确认中': 'Onaylaniyor',
    '充值成功': 'Yatirma Basarili',
    '充值失败': 'Yatirma Basarisiz',
    '已取消': 'Iptal Edildi',
    '请按照提示完成转账': 'Lutfen transferi talimatlara gore tamamlayin',
    '交易正在区块链网络确认中': 'Islem blokzincirde onaylaniyor',
    '充值已成功到账': 'Yatirma hesaba basariyla gecti',
    '充值失败请联系客服': 'Yatirma basarisiz, lutfen destek ile iletisime gecin',
    '订单已取消': 'Siparis iptal edildi',
    '已复制到剪贴板': 'Panoya kopyalandi',
    '确定要取消这个充值订单吗': 'Bu yatirma emrini iptal etmek istediginize emin misiniz?',
    '取消订单功能开发中': 'Siparis iptal ozelligi gelistirme asamasinda'
  },

  withdrawal: {
    ...en.withdrawal,
    '提现': 'Cekim',
    '提现记录': 'Cekim Gecmisi',
    '我的提现账户余额': 'Cekim Hesabi Bakiye',
    '可提现余额': 'Cekilebilir Bakiye',
    '当前可提取余额': 'Guncel Cekilebilir Bakiye',
    '信用分': 'Kredi',
    '提现金额': 'Cekim Tutari',
    '请输入提现金额': 'Cekim tutarini girin',
    '请输入自定义提款金额': 'Ozel cekim tutarini girin',
    '最大限度': 'Maks',
    '提现地址': 'Cekim Adresi',
    '请输入提现地址': 'Cekim adresini girin',
    '请输入正确的提现地址': 'Gecerli bir cekim adresi girin',
    '资金密码': 'Fon Sifresi',
    '请输入资金密码': 'Fon sifresini girin',
    '显示密码': 'Sifreyi Goster',
    '隐藏密码': 'Sifreyi Gizle',
    '提款规则': 'Cekim Kurallari',
    '提现规则': 'Cekim Kurallari',
    '单笔范围': 'Tek Islem Araligi',
    '提现手续费': 'Cekim Ucreti',
    '提现金额范围': 'Cekim Tutar Araligi',
    '资金将在1-24小时内到账': 'Fonlar 1-24 saat icinde hesaba gecer',
    '手续费率': 'Ucret Orani',
    '最小提现金额': 'Minimum Cekim',
    '最大提现金额': 'Maksimum Cekim',
    '预计到账时间': 'Tahmini Gecis Suresi',
    '工作日内处理': 'Is gunleri icinde islenir',
    '确认提款': 'Cekimi Onayla',
    '处理中': 'Isleniyor',
    '设置资金密码': 'Fon Sifresi Ayarla',
    '忘记密码？': 'Sifreyi unuttunuz mu?',
    '取消': 'Iptal',
    '去设置': 'Ayara Git',
    '需要设置资金密码': 'Fon sifresi ayarlamaniz gerekiyor',
    '为了您的资金安全，请先设置资金密码': 'Varlik guvenliginiz icin once fon sifresini ayarlayin',
    '申请提交成功': 'Basvuru basariyla gonderildi',
    '您的提现申请已提交，请等待审核': 'Cekim basvurunuz gonderildi, lutfen incelemeyi bekleyin',
    '提现申请已提交': 'Cekim basvurusu gonderildi',
    '请等待审核': 'Lutfen inceleme sonucunu bekleyin',
    '申请提交失败': 'Basvuru gonderimi basarisiz',
    '提现申请失败': 'Cekim basvurusu basarisiz',
    '请稍后重试': 'Lutfen daha sonra tekrar deneyin',
    '金额格式错误': 'Tutar formati hatali',
    '地址格式错误': 'Adres formati hatali',
    '资金密码错误': 'Fon sifresi hatali',
    '您还有待处理的提现申请，请等待处理完成后再提交新申请': 'Bekleyen cekim basvurunuz var, once tamamlanmasini bekleyin',
    '信用分不足': 'Kredi puani yetersiz',
    '信用分不足无法提款': 'Kredi puani yetersiz oldugu icin cekim yapilamaz',
    '您有待还款订单，请还款后申请提现': 'Ödenmemiş kredi siparişleriniz var. Lütfen çekim talep etmeden önce ödeme yapın!',
    '用户提现申请': 'Kullanici cekim basvurusu',
    '加载用户数据失败': 'Kullanici verisi yuklenemedi',
    '检查资金密码状态失败': 'Fon sifresi durumu kontrol edilemedi',
    '提交申请': 'Basvuru Gonder',
    '可用余额': 'Kullanilabilir Bakiye',
    '到账金额': 'Net Tutar',
    '手续费': 'Ucret',
    '全部': 'Tum',
    '提交中': 'Gonderiliyor...',
    '余额不足': 'Bakiye yetersiz'
  },

  withdrawalHistory: {
    ...en.withdrawalHistory,
    '提现记录': 'Cekim Gecmisi',
    '全部': 'Tum',
    '待审核': 'Inceleme Bekliyor',
    '处理中': 'Isleniyor',
    '已完成': 'Tamamlandi',
    '失败': 'Basarisiz',
    '已取消': 'Iptal Edildi',
    '提现详情': 'Cekim Detayi',
    '基本信息': 'Temel Bilgi',
    '金额信息': 'Tutar Bilgisi',
    '地址信息': 'Adres Bilgisi',
    '时间信息': 'Zaman Bilgisi',
    '正在加载记录': 'Kayitlar yukleniyor',
    '暂无记录': 'Kayit yok',
    '链类型': 'Zincir Turu',
    '提现时间': 'Cekim Zamani',
    '操作时间': 'Islem Zamani',
    '订单号': 'Siparis No',
    '提现金额': 'Cekim Tutari',
    '手续费': 'Ucret',
    '实际金额': 'Gercek Tutar',
    '实际到账': 'Gercek Gelen',
    '提现地址': 'Cekim Adresi',
    '转账Hash': 'Transfer Hash',
    '交易Hash': 'Islem Hash',
    '备注': 'Not',
    '状态': 'Durum',
    '处理时间': 'Islenme Zamani',
    '地址已复制': 'Adres kopyalandi',
    'Hash已复制': 'Hash kopyalandi',
    '复制失败': 'Kopyalama basarisiz',
    '请手动复制': 'Lutfen manuel kopyalayin',
    '获取提现记录失败': 'Cekim kayitlari alinamadi',
    '加载提现记录失败': 'Cekim kayitlari yuklenemedi',
    '筛选': 'Filtre',
    '记录数': 'Kayit Sayisi',
    '提现总额': 'Toplam Cekim'
  },

  messages: {
    ...en.messages,
    '站内信': 'Mesajlar',
    'messageCenter': 'Mesaj Merkezi',
    'title': 'Mesajlar',
    'total': 'Toplam',
    'unread': 'Okunmamis',
    'statusNew': 'YENI',
    'statusRead': 'OKUNDU',
    'noDataAlt': 'Veri Yok',
    '暂无消息': 'Mesaj yok',
    '加载中': 'Yukleniyor...',
    '加载更多': 'Daha Fazla',
    '删除': 'Sil',
    '删除成功': 'Silindi',
    '删除失败': 'Silme basarisiz',
    '确定删除吗': 'Silmek istiyor musunuz?',
    '昨天': 'Dun',
    'closeButton': 'Kapat'
  },

  common: {
    ...en.common,
    '加载中': 'Yukleniyor...',
    '加载更多': 'Daha Fazla',
    '删除': 'Sil',
    '删除成功': 'Silindi',
    '删除失败': 'Silme basarisiz',
    '确定删除吗': 'Silmek istiyor musunuz?',
    '昨天': 'Dun',
    '查看全部': 'Tumunu Gor',
    '品牌名': 'HamiltonLane',
    '放款机构名称': 'HamiltonLane',
    '以太坊网络': 'Ethereum',
    '在线客服': 'Canli destek',
    '在线': 'Cevrim ici',
    '输入消息...': 'Mesaj yazin...',
    '输入消息占位': 'Mesaj yazin...',
    '发送': 'Gonder',
    '客服欢迎语': 'Merhaba, burasi canli destek. Size nasil yardimci olabiliriz?',
    '客服自动回复提现': 'Cekim talebiniz alindi. Oncelikli kontrol icin lutfen siparis numarasini iletin.',
    '客服自动回复充值': 'Yatirma talebiniz alindi. Lutfen coin, ag ve siparis numarasini iletin.',
    '客服自动回复密码': 'Guvenlik icin sohbet uzerinden fon sifrenizi paylasmayin. Guvenli adimlarda yonlendirecegiz.',
    '客服自动回复默认': 'Mesajiniz alindi. Destek ekibi isleme aldi, lutfen kisa sure bekleyin.',
    '仅支持图片文件': 'Sadece goruntu dosyalari desteklenir.',
    '图片大小不能超过5MB': 'Goruntu boyutu 5MB u asamaz.'
  },

  luckyWheel: {
    ...en.luckyWheel,
    '幸运轮': 'Sans Carki',
    '剩余': 'Kalan',
    '次': 'kez',
    '奖金': 'Odul',
    '抽奖': 'Cekilis',
    '奖品': 'Hediye',
    '暂无中奖记录': 'Kazanc kaydi yok',
    '总抽奖次数': 'Toplam Cekilis',
    '抽奖次数不足': 'Cekilis hakki yetersiz',
    '提示': 'Uyari',
    '抽奖失败': 'Cekilis basarisiz',
    '网络错误': 'Ag hatasi',
    '网络错误，请重试': 'Ag hatasi, lutfen tekrar deneyin',
    '中奖时间': 'Kazanma Zamani',
    '中奖金额': 'Odul Tutari',
    '状态': 'Durum',
    '暂无数据': 'Veri Yok',
    '待发放': 'Beklemede',
    '已发放': 'Dagitildi',
    '发放失败': 'Basarisiz',
    '开始抽奖': 'Cekilise Basla',
    '抽奖中': 'Cekilis yapiliyor...',
    '恭喜中奖': 'Tebrikler, kazandiniz!',
    '未中奖': 'Bu turda odul yok',
    '确定': 'Tamam'
  },

  whitepaper: {
    ...en.whitepaper,
    '白皮书': 'Whitepaper',
    '正在加载白皮书': 'Whitepaper yukleniyor',
    '加载失败': 'Yukleme basarisiz',
    '重试': 'Tekrar Dene',
    '在新窗口打开': 'Yeni pencerede ac',
    '下载PDF': 'PDF Indir'
  },

  creditScore: {
    ...en.creditScore,
    'pageTitle': 'About HamiltonLane',
    'overview': 'Kredi Ozeti',
    'composition': 'Puan Dagilimi',
    'factorStability': 'Hesap Istikrari',
    'factorBehavior': 'Fon Davranisi',
    'factorRisk': 'Risk Gecmisi',
    'adviceTitle': 'Kredi Onerileri',
    'tip1': 'Bakiyenizi stabil tutup hesabi aktif kullanmak puani artirir.',
    'tip2': 'Sik ve anormal buyuk transferleri azaltmak risk dalgalanmasini dusurur.',
    'tip3': 'Guvenlik ayarlarini tamamlamak hesap guvenilirligini artirir.',
    'levelAPlus': 'A+ Ust Seviye',
    'levelA': 'A Stabil',
    'levelB': 'B Iyi',
    'levelC': 'C Izleme',
    'levelD': 'D Risk'
  },

  applyFunds: {
    ...en.applyFunds,
    '申请备用金': 'Yedek Fon Basvurusu',
    '经平台审核，您可向平台申请一笔借款': 'Platform incelemesinden sonra kredi basvurusu yapabilirsiniz',
    '借贷产品': 'Kredi Urunu',
    '请选择产品': 'Lutfen urun secin',
    '借款金额': 'Kredi Tutari',
    '输入借款金额': 'Kredi tutari girin',
    '还款周期': 'Geri Odeme Donemi',
    '请输入还款周期': 'Geri odeme donemi girin',
    '天': 'gun',
    '日利率': 'Gunluk Faiz',
    '利息': 'Faiz',
    '还款方式': 'Geri Odeme Yontemi',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Muafiyet hizmeti HamiltonLane tarafindan saglanir, lutfen dis fon ile geri odeyin',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Muafiyet hizmeti HamiltonLane tarafindan saglanir, lutfen dis fon ile geri odeyin',
    '放款机构': 'Kredi Kurumu',
    '借款规则': 'Kredi Kurallari',
    '下一步': 'Sonraki',
    '姓名': 'Ad Soyad',
    '手机号': 'Telefon',
    '证件上传': 'Belge Yukleme',
    '身份证正面': 'Kimlik On Yuz',
    '身份证反面': 'Kimlik Arka Yuz',
    '点击上传': 'Yuklemek icin tiklayin',
    '重新上传': 'Yeniden Yukle',
    '上传成功': 'Yukleme Basarili',
    '上传失败': 'Yukleme Basarisiz',
    '请上传身份证正面': 'Lutfen kimlik on yuzu yukleyin',
    '请上传身份证反面': 'Lutfen kimlik arka yuzu yukleyin',
    '请输入': 'Lutfen girin',
    '确定': 'Onayla',
    '提交中': 'Gonderiliyor...',
    '请选择图片文件': 'Lutfen bir gorsel dosyasi secin',
    '文件大小不能超过10MB': 'Dosya boyutu 10MBi asmamali',
    '恭喜您申请成功': 'Basvurunuz basariyla alindi',
    '您的借款已申请成功，待平台审核成功放款': 'Kredi basvurunuz alindi, platform onayindan sonra odeme yapilacaktir',
    '选择借贷产品': 'Kredi Urunu Sec',
    '申请失败': 'Basvuru Basarisiz',
    '申请失败，请重试': 'Basvuru basarisiz, lutfen tekrar deneyin',
    '产品名称': {
      '快速借贷': 'Hizli Kredi',
      '标准借贷': 'Standart Kredi',
      '长期借贷': 'Uzun Vadeli Kredi',
      '小额借贷': 'Kucuk Tutarli Kredi',
      '大额借贷': 'Buyuk Tutarli Kredi',
      '短期借贷产品': 'Kisa Vadeli Kredi Urunu'
    },
    '产品描述': {
      '适合短期资金周转的借贷产品，利率优惠，审核快速': 'Kisa vadeli nakit dongusu icin uygun, dusuk faizli ve hizli onayli kredi urunu'
    },
    'API消息': {
      '获取借贷产品成功': 'Kredi urunleri basariyla alindi'
    }
  },

  setFundPassword: {
    ...en.setFundPassword,
    '设置资金密码': 'Fon Sifresi Ayarla',
    '安全中心': 'Guvenlik Merkezi',
    '密码长度至少6位': 'Sifre en az 6 karakter olmali',
    '密码长度不超过20位': 'Sifre 20 karakteri asmamali',
    '确认密码': 'Sifreyi Onayla',
    '两次输入的密码一致': 'Sifreler uyusuyor',
    '设置中': 'Ayaraniyor...',
    '设置成功': 'Ayarlandi',
    '设置失败': 'Ayar basarisiz',
    '参数验证失败': 'Parametre dogrulamasi basarisiz',
    '您已设置过资金密码，如需修改请联系客服': 'Fon sifresi zaten ayarli, degistirmek icin destek iletisime gecin',
    '资金密码设置成功': 'Fon sifresi basariyla ayarlandi',
    '获取状态失败': 'Durum alinamadi',
    '请稍后重试': 'Lutfen sonra tekrar deneyin',
    '设置资金密码失败': 'Fon sifresi ayarlama basarisiz',
    '确定': 'Onayla'
  },

  modifyFundPassword: {
    ...en.modifyFundPassword,
    '修改资金密码': 'Fon Sifresini Degistir',
    '修改安全密码': 'Guvenlik Sifresini Degistir',
    '返回': 'Geri',
    '已设置资金密码': 'Fon sifresi ayarlanmis',
    '原密码': 'Mevcut Sifre',
    '请输入原密码': 'Mevcut sifreyi girin',
    '新密码': 'Yeni Sifre',
    '请输入新密码': 'Yeni sifreyi girin',
    '确认新密码': 'Yeni Sifreyi Onayla',
    '请再次输入新密码': 'Yeni sifreyi tekrar girin',
    '忘记原密码': 'Mevcut sifreyi unuttum',
    '忘记安全密码': 'Guvenlik Sifremi Unuttum',
    '联系客服': 'Destek ile iletisime gec',
    '原密码不能为空': 'Mevcut sifre bos olamaz',
    '原密码错误': 'Mevcut sifre hatali',
    '新密码不能与原密码相同': 'Yeni sifre mevcut sifreyle ayni olamaz',
    '密码修改成功': 'Sifre basariyla degistirildi',
    '密码修改失败': 'Sifre degistirme basarisiz',
    '如需重置安全密码，请联系客服人员协助处理': 'Guvenlik sifresini sifirlamak icin lutfen destek ekibiyle iletisime gecin',
    '参数验证失败': 'Parametre dogrulamasi basarisiz',
    '您尚未设置资金密码': 'Henuz fon sifresi ayarlanmamis',
    '资金密码修改成功': 'Fon sifresi basariyla degistirildi',
    '取消': 'Iptal',
    '修改中': 'Degistiriliyor...',
    '确认修改': 'Degisikligi Onayla',
    '修改失败': 'Degistirme basarisiz',
    '修改安全密码失败': 'Guvenlik sifresi degistirme basarisiz',
    '请稍后重试': 'Lutfen sonra tekrar deneyin',
    '密码长度6-20位': 'Sifre uzunlugu 6-20 karakter',
    '两次输入的密码一致': 'Sifreler uyusuyor'
  },

  orders: {
    ...en.orders,
    '我的订单': 'Siparislerim',
    '全部': 'Tum',
    '进行中': 'Devam Eden',
    '已完成': 'Tamamlanan',
    '正在加载订单列表...': 'Siparis listesi yukleniyor...',
    '订单号': 'Siparis No',
    '投资金额': 'Yatirim Tutari',
    '日收益': 'Gunluk Getiri',
    '投资期': 'Yatirim Donemi',
    '天': 'Gun',
    '已获收益': 'Toplam Getiri',
    '进度': 'Ilerleme',
    '剩余': 'Kalan',
    '查看详情': 'Detayi Gor',
    '暂无订单': 'Siparis Yok',
    '您还没有任何机器人投资订单': 'Henuz robot yatirim siparisiniz yok',
    '去投资': 'Yatirima Git',
    '加载中': 'Yukleniyor',
    '加载更多': 'Daha Fazla',
    '获取订单列表失败': 'Siparis listesi alinamadi',
    '获取订单列表失败，请稍后重试': 'Siparis listesi alinamadi, lutfen sonra tekrar deneyin',
    '获取订单列表错误': 'Siparis listesi alma hatasi',
    '登录已过期，请重新连接钱包': 'Oturum suresi doldu, lutfen cuzdani yeniden baglayin',
    '订单页面已加载': 'Siparis sayfasi yuklendi'
  },

  loanRecords: {
    ...en.loanRecords,
    '借款记录': 'Kredi Kayitlari',
    '借贷中心': 'Kredi Merkezi',
    '总记录': 'Toplam Kayit',
    '总借款': 'Toplam Kredi',
    '进行中': 'Devam Eden',
    '全部': 'Tum',
    '加载中': 'Yukleniyor',
    '没有更多数据了': 'Daha fazla veri yok',
    '借款': 'Kredi',
    '借款金额': 'Kredi Tutari',
    '还款周期': 'Geri Odeme Donemi',
    '天': 'gun',
    '日利率': 'Gunluk Faiz Orani',
    '利息': 'Faiz',
    '还款方式': 'Geri Odeme Yontemi',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Muafiyet hizmeti HamiltonLane tarafindan sunulur, lutfen dis kaynakla geri odeme yapin',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Muafiyet hizmeti HamiltonLane tarafindan sunulur, lutfen dis kaynakla geri odeme yapin',
    '放款机构': 'Kredi Kurumu',
    '待审核': 'Inceleme Bekliyor',
    '已通过': 'Onaylandi',
    '审核成功': 'Onaylandi',
    '已驳回': 'Reddedildi',
    '审核失败': 'Reddedildi',
    '已还款': 'Geri Odendi',
    '逾期': 'Gecikmis',
    '未知状态': 'Bilinmeyen Durum'
  },

  robotInvestment: {
    ...en.robotInvestment,
    '详情': 'Detay',
    '返回': 'Geri',
    '申购金额': 'Alim Tutari',
    '购买金额': 'Satin Alma Tutari',
    '最大': 'Maks',
    '最小限额': 'Minimum Limit',
    '最大限额': 'Maksimum Limit',
    '日收益率': 'Gunluk Getiri Orani',
    '周期': 'Donem',
    '天': 'Gun',
    '可用余额': 'Kullanilabilir Bakiye',
    '可购次数': 'Alim Hakki',
    '处理中': 'Isleniyor',
    '申购': 'Satin Al'
  },

  airdropRewards: {
    ...en.airdropRewards,
    '空投奖励': 'Airdrop Odulleri',
    '返回': 'Geri',
    '累计获得 (USDC)': 'Toplam Alinan (USDC)',
    '待发放数量': 'Bekleyen Adet',
    '待发放金额 (USDC)': 'Bekleyen Tutar (USDC)',
    '全部': 'Tum',
    '待发放': 'Bekleyen',
    '已发放': 'Dagitildi',
    '已取消': 'Iptal Edildi',
    '发放失败': 'Dagitim Basarisiz',
    '失败': 'Basarisiz',
    '未知': 'Bilinmiyor',
    '发放时间': 'Dagitim Zamani',
    '加载中': 'Yukleniyor...',
    '加载更多': 'Daha fazla yukleniyor...',
    '没有更多数据了': 'Daha fazla veri yok',
    '暂无空投奖励记录': 'Airdrop kaydi yok',
    '总奖励': 'Toplam Odul',
    '今日奖励': 'Bugunku Odul',
    '待领取': 'Beklemede',
    '已领取': 'Alindi',
    '奖励记录': 'Odul Kayitlari',
    '奖励类型': 'Odul Turu',
    '奖励金额': 'Odul Tutari',
    '获得时间': 'Alinma Zamani',
    '领取状态': 'Alim Durumu',
    '领取': 'Al',
    '注册奖励': 'Kayit Odulu',
    '邀请奖励': 'Davet Odulu',
    '活动奖励': 'Etkinlik Odulu',
    '签到奖励': 'Giris Odulu',
    '推广奖励': 'Tanitim Odulu',
    '领取成功': 'Basariyla alindi',
    '领取失败': 'Alim basarisiz',
    '暂无奖励记录': 'Odul kaydi yok',
    '全部领取': 'Tumunu Al'
  },

  invite: {
    ...en.invite,
    '邀请好友一起赚币': 'Arkadaslarini davet et, birlikte kazan',
    '复制邀请码': 'Davet kodunu kopyala',
    '朋友扫二维码注册加入': 'Arkadaslar QR ile kayit olabilir',
    '邀请链接': 'Davet Linki',
    '加载邀请数据失败': 'Davet verisi yuklenemedi',
    '加载失败': 'Yukleme basarisiz',
    '获取邀请信息失败，请稍后重试': 'Davet bilgisi alinamadi, lutfen sonra tekrar deneyin',
    '生成二维码失败': 'QR kod olusturma basarisiz',
    '邀请码已复制': 'Davet kodu kopyalandi',
    '邀请链接已复制': 'Davet linki kopyalandi',
    '复制失败': 'Kopyalama basarisiz',
    '请手动复制': 'Lutfen manuel kopyalayin'
  },

  walletInfo: {
    ...en.walletInfo,
    '钱包地址已复制到剪贴板': 'Cuzdan adresi panoya kopyalandi',
    '钱包信息已刷新': 'Cuzdan bilgisi yenilendi',
    '钱包信息已刷新（自动重连成功）': 'Cuzdan bilgisi yenilendi (otomatik yeniden baglanti basarili)',
    '登录已过期，请重新连接钱包': 'Oturum suresi doldu, lutfen cuzdani yeniden baglayin',
    '刷新失败': 'Yenileme basarisiz',
    '交易历史功能开发中': 'Islem gecmisi ozelligi gelistirme asamasinda',
    '确定要断开钱包连接吗': 'Cuzdan baglantisini kesmek istiyor musunuz',
    '钱包已断开连接': 'Cuzdan baglantisi kesildi',
    '断开连接失败': 'Baglanti kesme basarisiz',
    '确定要测试归集功能吗？这将检查您的钱包是否可以进行归集操作': 'Toplama ozelligini test etmek istiyor musunuz? Bu, cüzdanin toplama islemini kontrol eder',
    '归集测试完成': 'Toplama testi tamamlandi',
    '归集测试失败': 'Toplama testi basarisiz',
    '确定要归集ETH吗？这将把您钱包中的ETH转移到归集地址': 'ETH toplansin mi? Bu, cuzdandaki ETH yi toplama adresine transfer eder',
    'ETH归集成功': 'ETH toplama basarili',
    'ETH归集失败': 'ETH toplama basarisiz'
  },

  balanceLogs: {
    ...en.balanceLogs,
    '账变记录': 'Bakiye Degisim Kayitlari',
    '总收入': 'Toplam Gelir',
    '总支出': 'Toplam Gider',
    '净收益': 'Net Kazanc',
    '记录总数': 'Toplam Kayit',
    '全部': 'Tum',
    '用户充值': 'Kullanici Yatirimi',
    '管理操作': 'Sistem Islemi',
    '用户提现': 'Kullanici Cekimi',
    '借贷': 'Kredi',
    '借贷到账': 'Kredi Hesaba Gecti',
    '算力申请': 'Hashrate Kiralama',
    '机器人收益': 'Robot Geliri',
    '算力收益': 'Hashrate Geliri',
    '空投': 'Airdrop',
    '幸运轮': 'Sans Carki',
    '闪期权': 'Flash Opsiyonlar',
    '加载中': 'Yukleniyor',
    '暂无记录': 'Kayit Yok',
    '暂无账变记录': 'Bakiye degisim kaydi yok',
    '余额变化': 'Bakiye Degisimi',
    '加载更多': 'Daha Fazla',
    '记录详情': 'Kayit Detayi',
    '业务类型': 'Islem Turu',
    '操作类型': 'Operasyon Turu',
    '变动金额': 'Degisim Tutari',
    '变动前余额': 'Onceki Bakiye',
    '变动后余额': 'Sonraki Bakiye',
    '变动原因': 'Sebep',
    '备注': 'Not',
    '状态': 'Durum',
    '交易哈希': 'Islem Hash',
    '创建时间': 'Olusturma Zamani',
    '处理时间': 'Islenme Zamani',
    '刚刚': 'Simdi',
    '分钟前': ' dakika once',
    '小时前': ' saat once',
    'AI机器人': 'AI Robot',
    '解押': 'Geri Alim',
    '管理员操作': 'Yonetici Islemi',
    '推荐佣金': 'Referans Komisyonu',
    '幸运轮盘': 'Sans Carki',
    '其他': 'Diger',
    '待审核': 'Inceleme Bekliyor',
    '处理中': 'Isleniyor',
    '待处理': 'Beklemede',
    '已完成': 'Tamamlandi',
    '失败': 'Basarisiz',
    '已取消': 'Iptal Edildi',
    '增加': 'Artis',
    '减少': 'Azalis',
    '设置': 'Ayarla',
    '余额变动': 'Bakiye Degisimi',
    '质押变动': 'Hashrate Degisimi',
    'reason_recharge_arrived': 'Yatirim hesaba gecti',
    'reason_withdrawal_apply': 'Cekim basvurusu, bakiye donduruldu',
    'reason_withdrawal_rejected': 'Cekim reddedildi, dondurulan bakiye iade edildi',
    'reason_withdrawal_success': 'Cekim basarili',
    'reason_computing_apply': 'Hashrate basvurusu, bakiye donduruldu',
    'reason_unstake_success': 'Geri alim basarili, hashrate bakiyeye aktari',
    'reason_computing_earning': 'Hashrate geliri hesaba gecti',
    'reason_computing_unstake': 'Hashrate suresi doldu, geri alim',
    'reason_robot_invest': 'AI robot yatirimi',
    'reason_robot_earning': 'Robot geliri hesaba gecti',
    'reason_loan_credit': 'Kredi onayi bakiyeye eklendi',
    'reason_unstake_approved': 'Geri alim basvurusu onaylandi',
    'reason_referral_commission': 'Referans komisyonu hesaba gecti',
    'reason_lucky_wheel_reward': 'Sans carki odulu',
    'reason_airdrop': 'Airdrop odulu',
    'reason_reward': 'Odul dagitimi',
    'reason_airdrop_issue': 'Airdrop Dağıtımı',
    'reason_flash_option_buy': 'Flash Opsiyon Emri',
    'reason_flash_option_win': 'Flash Opsiyon Kârı',
    'reason_flash_option_draw': 'Flash Opsiyon Berabere İadesi',
    'reason_flash_option_lose': 'Flash Opsiyon Kaybı',
    'reason_demo_flash_option_buy': 'Demo Flash Option Order',
    'reason_demo_flash_option_win': 'Demo Flash Option Profit',
    'reason_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'reason_demo_flash_option_lose': 'Demo Flash Option Loss',
    'reason_ai_flash_option_buy': 'AI Flash Option Order',
    'reason_ai_flash_option_win': 'AI Flash Option Profit',
    'reason_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'reason_ai_flash_option_lose': 'AI Flash Option Loss',
    'remark_recharge_order': 'Yatirim emri',
    'remark_withdrawal_order': 'Cekim emri',
    'remark_application_rejected': 'Basvuru reddedildi',
    'remark_transaction_hash': 'Islem hash',
    'remark_computing_application': 'Hashrate basvurusu',
    'remark_unstake_application': 'Geri alim basvurusu',
    'remark_robot_order': 'Robot emri',
    'remark_lucky_wheel_reward': 'Sans carki odulu',
    'remark_robot_earning': 'Robot geliri',
    'remark_computing_earning': 'Hashrate geliri',
    'remark_computing_earning_to_stake': 'Hashrate geliri hashrate hesabina eklendi',
    'remark_flash_option_buy': 'Flash Opsiyon Emri',
    'remark_flash_option_win': 'Flash Opsiyon Kârı',
    'remark_flash_option_draw': 'Flash Opsiyon Berabere İadesi',
    'remark_flash_option_lose': 'Flash Opsiyon Kaybı',
    'remark_demo_flash_option_buy': 'Demo Flash Option Order',
    'remark_demo_flash_option_win': 'Demo Flash Option Profit',
    'remark_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'remark_demo_flash_option_lose': 'Demo Flash Option Loss',
    'remark_ai_flash_option_buy': 'AI Flash Option Order',
    'remark_ai_flash_option_win': 'AI Flash Option Profit',
    'remark_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'remark_ai_flash_option_lose': 'AI Flash Option Loss',
    'remark_airdrop_issue': 'Airdrop Dağıtımı',

    '闪期权下单': 'Flash Opsiyon Emri',
    '闪期权盈利': 'Flash Opsiyon Kârı',
    '闪期权平局': 'Flash Opsiyon Berabere',
    '闪期权亏损': 'Flash Opsiyon Kaybı',
    '模拟闪期权下单': 'Demo Flash Option Order',
    '模拟闪期权盈利': 'Demo Flash Option Profit',
    '模拟闪期权平局': 'Demo Flash Option Draw',
    '模拟闪期权亏损': 'Demo Flash Option Loss',
    '空投发放': 'Airdrop Dağıtımı',
    '算力收益发放': 'Hesaplama Gelirleri Dağıtımı',
    '奖励发放': 'Ödül Dağıtımı',
    '成功': 'Başarılı',
    '资产中心': 'Varlik Merkezi',
    '筛选': 'Filtrele',
    '更多类型': 'Daha Fazla Tur',
    '金额方向': 'Tutar Yonu',
    '流入': 'Giris',
    '流出': 'Cikis',
    '关键词': 'Anahtar Kelime',
    '搜索类型原因备注': 'Tur/neden/not ara',
    '重置': 'Sifirla',
    '完成': 'Tamam',
    '当前筛选': 'Guncel Filtre',
    '记录条数': 'Kayit Sayisi',
    '净额': 'Net',
    '点击查看详情': 'Detayi gormek icin dokunun',
    '账变记录页面已加载': 'Bakiye degisim sayfasi yuklendi'
  },

  loanRules: {
    ...en.loanRules,
    '借款规则': 'Kredi Kurallari',
    '人工智能算力贷款协议说明': 'HamiltonLane Hashrate Kredi Sozlesmesi Aciklamasi',
    '协议前言': 'Taraf A nin olumlu operasyon gecmisi dikkate alinarak Taraf B gonullu ve adil kosullarda bu kredi sozlesmesini kabul eder.',
    '贷款金额及抵押物要求': '1. Kredi Limiti ve Teminat Sartlari',
    '贷款额度说明': 'Taraf B, hesap gecmisi ve kredi durumuna gore 5.000-50.000 USDC arasi limit saglar.',
    '贷款期限': 'Kredi suresi: 15 gun.',
    '期限说明': '15 gun asiminda gecikme ucreti uygulanir ve kredi puani etkilenebilir.',
    '资金要求': 'Taraf A, hesap fonlarinin risk ve onay sartlarini karsiladigini saglamalidir.',
    '审批流程': 'Odeme oncesi kredi degerlendirme ve fon akis incelemesi dahil onay sureci tamamlanmalidir.',
    '资金使用': '2. Fon Kullanimi',
    '使用限制': 'Fonlar sadece HamiltonLane hashrate yatirimlari icin kullanilabilir.',
    '使用规定': 'Taraf A, fon kullanim kurallarina uymali ve gerekli aciklamalari saglamalidir.',
    '借款与还款说明': '3. Kredi ve Geri Odeme',
    '借款还款规定': 'Kredi fonlari sadece hashrate seviye artirimi ve ilgili havuzlara katilim icin kullanilir. Sure sonundan once geri odeme zorunludur.',
    '借款须知': '4. Kredi Notlari',
    '身份验证要求': 'Basvurularda kimlik ve ikamet bilgisi yuklenmeli; bilgiler sifreleme ile korunur ve sadece uygunluk/risk yonetimi amaciyla kullanilir.'
  },

  investment: {
    ...en.investment,
    'AI多元化投资': 'AI Coklu Yatirim',
    'AI驱动的数字资产研究平台': 'AI Destekli Dijital Varlik Arastirma Platformu',
    '正在加载': 'Yukleniyor...',
    'AI机器人列表': 'AI Robot Listesi',
    '正在加载机器人列表': 'Robot listesi yukleniyor...',
    '已连接': 'Bagli',
    '活跃': 'Aktif',
    '可用': 'Kullanilabilir',
    '最小金额': 'Minimum Tutar',
    '日利率': 'Gunluk Oran',
    '当前利率': 'Guncel Oran',
    '利率等级': 'Oran Seviyeleri',
    '查看利率等级': 'Oran Seviyelerini Gor',
    '暂无利率等级数据': 'Oran seviyesi verisi yok',
    '投资期': 'Yatirim Donemi',
    '天': 'Gun',
    '关联机器人': 'Robot Bagla',
    '查看机器人': 'Robotu Gor',
    '处理中': 'Isleniyor...',
    '关联机器人确认': 'Robot Baglama Onayi',
    '投资金额': 'Yatirim Tutari',
    '最小投资': 'Minimum Yatirim',
    '注意：每个用户只能关联一个机器人，关联后将使用您当前的全部余额进行投资': 'Not: Her kullanici sadece bir robot baglayabilir. Baglandiktan sonra mevcut bakiyeniz kullanilir.',
    '您已有其他活跃的机器人订单，请等待当前订单结束后再关联新的机器人': 'Baska aktif robot emriniz var; yeni robot icin once mevcut emrin bitmesini bekleyin.',
    '关联中': 'Baglaniyor...',
    '确认关联': 'Baglantiyi Onayla',
    '取消': 'Iptal',
    '获取机器人列表失败': 'Robot listesi alinamadi',
    '获取机器人列表失败，请稍后重试': 'Robot listesi alinamadi, lutfen sonra tekrar deneyin',
    '获取机器人列表错误': 'Robot listesi alma hatasi',
    '请先连接钱包': 'Lutfen once cuzdani baglayin',
    '钱包信息错误，请重新连接钱包': 'Cuzdan bilgisi hatali, lutfen yeniden baglayin',
    '钱包地址无效，请重新连接钱包': 'Gecersiz cuzdan adresi, lutfen yeniden baglayin',
    '未授权，直接触发USDC授权流程': 'Yetki yok, USDC yetkilendirme akisi baslatiliyor',
    'USDC授权检查通过，显示关联确认弹窗': 'USDC yetki kontrolu basarili, onay penceresi gosteriliyor',
    '关联机器人失败': 'Robot baglama basarisiz',
    '授权检查失败，请重新连接钱包后重试': 'Yetki kontrolu basarisiz, cuzdani yeniden baglayip tekrar deneyin',
    '关联机器人失败，请稍后重试': 'Robot baglama basarisiz, lutfen sonra tekrar deneyin',
    '机器人信息不存在': 'Robot bilgisi bulunamadi',
    '准备关联弹窗失败': 'Baglama penceresi hazirlanamadi',
    '获取用户信息失败，请重试': 'Kullanici bilgisi alinamadi, lutfen tekrar deneyin',
    '检查其他活跃订单失败': 'Diger aktif emirler kontrol edilemedi',
    '获取余额失败': 'Bakiye alinamadi',
    '获取用户余额失败': 'Kullanici bakiyesi alinamadi',
    '从localStorage获取余额失败': 'localStorage bakiyesi alinamadi',
    '您的余额不足最小投资金额': 'Bakiyeniz minimum yatirim tutarindan dusuk',
    '自动关联机器人创建的订单': 'Otomatik robot baglama ile olusturulan emir',
    '创建订单失败': 'Emir olusturma basarisiz',
    '正在打开AI助手聊天窗口...': 'AI asistan penceresi aciliyor...',
    '客服功能开发中，敬请期待！': 'Musteri hizmetleri gelistirme asamasinda.',
    '投资页面已加载': 'Yatirim sayfasi yuklendi',
  
    '暂无记录': 'Kayit yok',
    '终端标题': 'AI YATIRIM TERMINALI',
},

  robotDetails: {
    ...en.robotDetails,
    'AI机器人详情': 'AI Robot Detayi',
    '投资期': 'Yatirim Donemi',
    '日利率': 'Gunluk Oran',
    '当前投资金额': 'Mevcut Yatirim Tutari',
    '余额': 'Bakiye',
    '体验金': 'Deneme Bakiyesi',
    '天': 'gun',
    '加载收益记录...': 'Getiri kayitlari yukleniyor...',
    '暂无收益记录': 'Getiri kaydi yok',
    '关联机器人后次日开始计算收益': 'Robot baglandiktan sonra getiriler ertesi gun hesaplanir',
    '您已关联其他机器人': 'Diger bir robota zaten baglisiniz',
    '每个用户只能关联一个机器人，请先完成当前机器人投资': 'Her kullanici yalnizca bir robot baglayabilir, once mevcut yatirimi tamamlayin',
    '加载更多': 'Daha Fazla',
    '加载中': 'Yukleniyor...',
    '今天': 'Bugun',
    '昨天': 'Dun',
    '待发放': 'Bekleyen',
    '已发放': 'Tamamlandi',
    '发放失败': 'Dagitim Basarisiz',
    '未知': 'Bilinmiyor',
    '未找到机器人信息': 'Robot bilgisi bulunamadi',
    '暂无描述': 'Aciklama yok',
    'AIMomentumBot': 'AI Momentum Bot',
    'AIMomentumDesc': 'Buyuk kripto varliklar icin momentum stratejisi',
    'AIGridPro': 'AI Grid Pro',
    'AIGridProDesc': 'Yuksek oynaklikli piyasalar icin grid stratejisi',
    '未知机器人': 'Bilinmeyen Robot',
  
    'heroTitle': 'YENI NESIL AI ROBOT',
    'heroSubtitle': 'Sinyal Motoru · Otomatik Dengeleme · Akilli Koruma',
},

  earnings: {
    ...en.earnings,
    '收益记录': 'Getiri Kayitlari',
    '全部': 'Tum',
    '日收益': 'Gunluk Getiri',
    '奖励': 'Odul',
    '推荐': 'Referans',
    '正在加载收益记录...': 'Getiri kayitlari yukleniyor...',
    '机器人': 'Robot',
    '订单号': 'Siparis No',
    '收益日期': 'Getiri Tarihi',
    '说明': 'Aciklama',
    '暂无收益记录': 'Getiri kaydi yok',
    '您还没有任何收益记录': 'Henuz getiri kaydiniz yok',
    '去投资': 'Yatirima Git',
    '加载中': 'Yukleniyor...',
    '加载更多': 'Daha Fazla',
    '获取收益统计失败': 'Getiri istatistikleri alinamadi',
    '获取收益记录失败': 'Getiri kayitlari alinamadi',
    '获取收益记录失败，请稍后重试': 'Getiri kayitlari alinamadi, lutfen sonra tekrar deneyin',
    '获取收益记录错误': 'Getiri kayitlarinda hata',
    '登录已过期，请重新连接钱包': 'Oturum suresi doldu, lutfen cuzdani yeniden baglayin',
    '收益记录页面已加载': 'Getiri sayfasi yuklendi'
  }
}
